export default __webpack_public_path__ + "static/media/logo.ec8f46ae.png";